import React from 'react'

import {useAtom, useCtx} from '@reatom/npm-react'
import './style.css'
import SvgSprite from 'championship/src/components/Utils/SvgSprite'
import {
  requestsAtom,
  participantsAtom,
  tournamentIdAtom, acceptRequest,
  leagueSlugAtom,
  getPlayerName
} from '../../model'

import {motion, usePresence} from 'motion/react'
import {getBlandID, getCSRFToken} from '../../utils'
import Swal from 'sweetalert2'
import {Dialog} from 'championship/src/classes/helpers/dialog'
import Avatar from 'championship/src/components/Utils/Image/Avatar'

// import { participantAtom } from '/../../model'
const transition = {
  type: 'spring',
  stiffness: 500,
  damping: 50,
  mass: 1
}

function MembersItem({num, source}) {
  const ctx = useCtx()
  const [isPresent, safeToRemove] = usePresence()
  const animations = {
    layout: true,
    initial: 'out',
    style: {
      //   color: color.hex(),
      //   position: isPresent ? 'relative' : 'absolute'
    },
    animate: isPresent ? 'in' : 'out',
    whileTap: 'tapped',
    variants: {
      //   in: { scaleY: 1, opacity: 1, zIndex: 0 },
      //   out: { scaleY: 0, opacity: 0, zIndex: -1 },
      in: {scaleY: 1, opacity: 1},
      out: {scaleY: 0, opacity: 0, transition: {duration: 0.1}},
      //   tapped: { scale: 0.98, opacity: 0.5, transition: { duration: 0.1 } }
    },
    onAnimationComplete: () => !isPresent && safeToRemove(),
    transition
  }

  const [requests, setRequests] = useAtom(requestsAtom)

  const name = getPlayerName(source.player)

  function rejectRequestHandler() {
    Dialog.ask({
      title: "Подтверждение",
      text: `Вы уверены, что хотите отклонить запрос игрока ${name}?`,
    })
      .then((result) => {
        if (result.isConfirmed) {
          const tournament_id = ctx.get(tournamentIdAtom)
          const league_slug = ctx.get(leagueSlugAtom)
          const form_data = new FormData()
          form_data.append('_reject', true)
          fetch(`/accounts/organizer/${league_slug}/tournaments/${tournament_id}/request/${source.id}`, {
            body: form_data,
            method: 'POST',
            headers: {
              // 'Accept': 'application/json',
              // 'Content-Type': 'application/json',
              // "X-Requested-With": "XMLHttpRequest",
              'X-CSRFToken': getCSRFToken()
            }
          })
            .then(resolve => {
              // console.log(resolve)
              if (resolve.status == 200) {
                const _requests = requests.filter((item) => item.player.id != source.player.id)
                setRequests(_requests)
              } else {
                // console.log(resolve)
              }
            })
            .catch(error => {
              // console.log(error)
            })
        }
      });
  }

  function acceptRequestHandler() {
    acceptRequest(ctx, source)
  }

  const year_date = new Date(source.player.birth_date)

  return (
    <motion.tr className="members-table-item" {...animations}>
      <td>{num}</td>
      <td>
        <Avatar object={source.player} />
      </td>
      <td>{name}</td>
      <td className="f-d-lg-table-cell f-d-none">
        {year_date.getFullYear()}
      </td>
      <td className="f-d-lg-table-cell f-d-none">
        {source.player.rank}
      </td>
      <td className="f-d-lg-table-cell f-d-none">
        {source.player.region}
      </td>
      <td className="members-table-item__actions-tr">
        <div className="members-table-item__actions">
          <div className="members-table-item__action -reject" onClick={rejectRequestHandler}>
            <SvgSprite id="close"/>
          </div>
          <div className="members-table-item__action -accept" onClick={acceptRequestHandler}>
            <SvgSprite id="add"/>
          </div>
        </div>
      </td>
    </motion.tr>
  )
}

export default MembersItem